import {ref, unref, watch} from 'vue';
import {useHttpRequest} from '~/composables/useHttpRequest';
import {useAuthService} from '~/composables/useAuthService';
import {endpoints} from '~/network/endpoints';

/**
 * The current user's outstanding entry-fee obligation for one competition, for
 * the "pay now" banner on ladder / league / tournament detail pages. `sourceId`
 * may be a ref (the league page's viewed cycle changes) — the fetch re-runs when
 * it does. Returns the single Due obligation (or null) plus a refresh; the
 * PayEntryFeeDialog emits 'paid' which the page wires to refresh().
 */
export function useEntryFeeObligation(sourceId) {
  const {httpRequest} = useHttpRequest();
  const {isAuthenticated} = useAuthService();

  const obligation = ref(null);

  const refresh = async () => {
    const id = unref(sourceId);
    if (!isAuthenticated.value || !id) {
      obligation.value = null;
      return;
    }
    try {
      const list = await httpRequest({
        ...endpoints.payments.myEntryFeeObligations,
        path: endpoints.payments.myEntryFeeObligations.path + `?sourceIds=${id}`,
      });
      obligation.value = (list || [])[0] || null;
    } catch (e) {
      obligation.value = null;
    }
  };

  watch(() => unref(sourceId), refresh);

  return {obligation, refresh};
}
